import styled from 'styled-components';

export const DataDeletionSec = styled.div`
color: #fff;
padding: 160px 0;
background: #fff;
`;

export const DataDeletionSection = styled.div`
color: #fff;
padding: 25px 0;
background: #fff;
`;

export const Heading = styled.h1`
margin-bottom: 10px;
font-size: 48px;
line-height: 1.1;
color: black;
font-family: 'Poppins', sans-serif;
font-weight: bold;
`;

export const Subtitle = styled.h2`
max-width: auto;
margin-bottom: 10px;
font-size: 18px;
line-height: 24px;
font-family: 'Inter', sans-serif;
color : black;
`;

export const Subtitleh3 = styled.h3`
max-width: auto;
margin-bottom: 10px;
font-size: 16px;
line-height: 24px;
font-family: 'Inter', sans-serif;
color : black;
`;

export const Text = styled.p`
max-width: auto;
margin-bottom: 10px;
font-size: 16px;
line-height: 24px;
font-family: 'Inter', sans-serif;
color : black;
`;

export const Subtext = styled.p`
max-width: auto;
margin-bottom: 10px;
font-size: 12px;
line-height: 24px;
font-family: 'Inter', sans-serif;
color : black;
`;

export const Lista = styled.ul`
max-width: auto;
margin-left: 30px;
color: black;
`;

export const ListaItem = styled.li`
margin-bottom: 8px;
`;

export const FormSection = styled.div`
background: #f8f9fa;
padding: 30px;
border-radius: 10px;
margin: 20px 0;
box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

export const FormLabel = styled.label`
display: block;
font-family: 'Inter', sans-serif;
font-size: 14px;
font-weight: 600;
color: #333;
margin-bottom: 8px;
`;

export const FormInput = styled.input`
width: 100%;
padding: 12px 16px;
font-size: 14px;
font-family: 'Inter', sans-serif;
border: 1px solid #ddd;
border-radius: 6px;
margin-bottom: 16px;
transition: border-color 0.3s;

&:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}
`;

export const FormTextarea = styled.textarea`
width: 100%;
padding: 12px 16px;
font-size: 14px;
font-family: 'Inter', sans-serif;
border: 1px solid #ddd;
border-radius: 6px;
margin-bottom: 16px;
min-height: 120px;
resize: vertical;
transition: border-color 0.3s;

&:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}
`;

export const SubmitButton = styled.button`
background: #007bff;
color: white;
padding: 12px 30px;
font-size: 16px;
font-weight: 600;
font-family: 'Inter', sans-serif;
border: none;
border-radius: 6px;
cursor: pointer;
transition: background 0.3s;

&:hover {
  background: #0056b3;
}

&:disabled {
  background: #ccc;
  cursor: not-allowed;
}
`;

export const AlertBox = styled.div`
padding: 16px;
margin: 20px 0;
border-radius: 6px;
font-family: 'Inter', sans-serif;
font-size: 14px;

${props => props.type === 'info' && `
  background: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
`}

${props => props.type === 'success' && `
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
`}

${props => props.type === 'warning' && `
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
`}
`;

export const ContactBox = styled.div`
background: #e7f3ff;
padding: 20px;
border-left: 4px solid #007bff;
border-radius: 6px;
margin: 20px 0;
`;

export const EmailLink = styled.a`
color: #007bff;
text-decoration: none;
font-weight: 600;

&:hover {
  text-decoration: underline;
}
`;
